export const LOAD_SURVEY = 'surveyForm/loadSurvey';
export const PREPARE_RESPONSE = 'surveyForm/prepareResponse';
export const UPDATE_RESPONSE = 'surveyForm/updateResponse';
export const HAS_DETAIL_LOADED = 'surveyForm/hasDetailLoaded';
export const SHOW_ALERT = 'surveyForm/showAlert';
export const SHOW_CONFIRM_MODAL = 'surveyForm/showConfirmModal';
export const UPDATE_CONFIRM_MODAL = 'surveyForm/updateConfirmModal';
export const SHOW_SURVEY_FORM_AFTER_SUBMIT_MODAL = 'surveyForm/showSurveyFormAfterSubmitModal';
export const UPDATE_SUBMITTED_DATE = 'surveyForm/updateSubmittedDate';
export const UPDATE_MODIFIED_DATE = 'surveyForm/updateModifiedDate';
export const UPDATE_IS_CLOSED = 'surveyForm/updateIsClosed';
export const SET_APP_IDD = 'surveyForm/setAppID';
